import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";

import { LgdPasswordComponent } from "./lgdPassword.component";

import { defineTextFieldComponent, defineTooltipComponent } from "@tylertech/forge";
import { ForgeModule } from "@tylertech/forge-angular";

defineTextFieldComponent();
defineTooltipComponent();

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        ForgeModule,
    ],
    declarations: [LgdPasswordComponent],
    exports: [
        ReactiveFormsModule,
        LgdPasswordComponent
    ],
    providers: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LgdPasswordModule { }
